/**
 * Validate email by regex
 * src: http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
 * @param  {string} email email to validate
 * @return {boolean} True or False
 */
export function validateEmail (email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  return re.test(email)
}

/**
 * Validate alphanumeric value (dashes and commas authorized)
 * @param  {string} value value to validate
 * @return {boolean} True or False
 */
export function validateAlphanumeric (value) {
  const alphaNumReg = /^[0-9a-zA-ZÀ-ž-_.,;\s]+$/
  return value && value.match(alphaNumReg)
}

export function nth (dayNumber) {
  if (dayNumber > 3 && dayNumber < 21) return 'th'
  switch (dayNumber % 10) {
    case 1: return 'st'
    case 2: return 'nd'
    case 3: return 'rd'
    default: return 'th'
  }
}
